// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-input[data-v-6fd1c5a4]{min-height:50px!important}.base-input.mobile[data-v-6fd1c5a4]{min-height:35px!important;font-size:16px!important}.base-input label[data-v-6fd1c5a4]{text-transform:uppercase!important;font-size:12px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
